import { render, staticRenderFns } from "./AlertCart.vue?vue&type=template&id=f36a7200"
import script from "./AlertCart.vue?vue&type=script&lang=js"
export * from "./AlertCart.vue?vue&type=script&lang=js"
import style0 from "./AlertCart.vue?vue&type=style&index=0&id=f36a7200&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports